export default `---
slug: value-investor
title: "Value Investor"
year: 2023
category: personal
featured: false
tags: [Python, ARIMA, Time Series, Bollinger Bands, Finance, Apziva]
thumbnail: /images/projects/17_vecho_time_series.png
description: "Forecasting stock prices with ARIMA and ARIMAX, then crafting a Bollinger Bands strategy. Results: +9.62% average. Method: definitely overfitting."
relatedLinks:
  - label: "Apziva Data Science Bootcamp"
    href: /career/apziva-bootcamp
---

This is the fifth project I did with [Apziva](https://www.apziva.com/), a Data Science bootcamp that I attended for the most part of 2023.
Apziva provided me the dataset for the project, and a mentor whom I would have weekly meetings with, to support my progress. Except for Bhargav (my mentor), I did everything alone, *and with Claude, who am I kidding*.

This project ([GitHub repo](https://github.com/Ilvecho/Value-Investor)) covered Time Series forecasting, another topic that I briefly touched in University (*I definitely needed a refresh*).

![Student in NL doing Time Series Forecasting](/images/projects/17_vecho_time_series.png)

In this project, I focused on creating models to forecast stock prices and create an investment strategy.
*Because we all know that the stock market is the easiest thing to forecast*

- I conducted an extensive Exploratory Data Analysis on various stock prices, with a particular focus on stationarity, autocorrelation, and exogenous variables' correlation.
- With the insights on the data, I utilized ARIMA models to model the stock prices, identifying the optimal model order for each asset.
- Then, I identified the most significant exogenous variables and integrated them into the ARIMAX models, providing a more comprehensive picture.
- To conclude the forecasting part, I implemented a Rolling Forecast Origin model to predict stock prices on a daily basis, ensuring that our insights were timely and relevant for investment decisions.
- Lastly, I deployed Bollinger Bands to craft an investment strategy that harnessed the power of the predictions, with a focus on risk management and optimization
- *Somehow*, I managed to obtain positive profits across all analyzed stocks, with the worst result at +2.01%, an average result of +9.62%, and the best result soaring to +19.40%.
  *I actually know how, it's called overfitting - so don't take financial advice from me*

It goes without saying that I did the project in Python, using Google computing power (*Colab one love*).
I would love to tell you more about the project, but I don't really remember and I am too lazy to check the Jupyter notebook - it is linked at the top, if you are curious go check it out!
`;
